import { ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";
import { forwardRef } from "react";

export type SHToggleButtonGroupProps = ToggleButtonGroupProps;

export const SHToggleButtonGroup = forwardRef<
  HTMLButtonElement,
  SHToggleButtonGroupProps
>((props, ref): JSX.Element => <ToggleButtonGroup {...props} ref={ref} />);
